import { useQuery } from '@tanstack/react-query';
import paymentProvidersApi from '@/features/dashboard/paymentProviders/api/paymentProvidersApi.ts';
import { paymentProvidersApiQueryKeys } from '@/features/dashboard/paymentProviders/api/paymentProvidersApi.queryKeys.ts';

const useGetPaymentProviderStatus = () => {
  return useQuery({
    queryKey: paymentProvidersApiQueryKeys.status(),
    queryFn: paymentProvidersApi.getStatus,
  });
};

export default useGetPaymentProviderStatus;
